import store from '@/state/store'
import AdminUtils from '@/helpers/admin'
import { Role } from '@/helpers/role'

export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        const adminId = store.getters['auth/getUser'].uid;
        await AdminUtils.addAction({
          adminId: adminId,
          type: 'logout'
        });
        await store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'users-dashboard' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
    meta: {
      section: "404"
    }
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
    meta: {
      section: "404"
    }
  },
  {
    path: '/403',
    name: '403',
    component: require('./views/utility/403').default,
    meta: {
      section: "403"
    }
  },
  // dashboards
  {
    path: '/dashboard/users',
    alias: '/',
    name: 'users-dashboard',
    meta: {
      authRequired: true,
      section: "users-dashboard",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/dashboards/users')
  },
  {
    path: '/dashboard/financials',
    name: 'financials-dashboard',
    meta: {
      authRequired: true,
      section: "financials-dashboard",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/dashboards/financials')
  },
  {
    path: '/dashboard/likes',
    name: 'likes-dashboard',
    meta: {
      authRequired: true,
      section: "likes-dashboard",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/dashboards/likes')
  },
  {
    path: '/dashboard/score',
    name: 'score-dashboard',
    meta: {
      authRequired: true,
      section: "score-dashboard",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/dashboards/score')
  },
  {
    path: '/dashboard/reviews',
    name: 'reviews-dashboard',
    meta: {
      authRequired: true,
      section: "reviews-dashboard",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/dashboards/reviews')
  },
  {
    path: '/dashboard/firebase',
    name: 'firebase-dashboard',
    meta: {
      authRequired: true,
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/dashboards/firebase')
  },
  // users routes
  {
    path: '/users/search',
    name: 'users-search',
    meta: {
      authRequired: true,
      section: "user",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/users/search')
  },
  {
    path: '/users/media',
    name: 'users-media',
    meta: {
      authRequired: true,
      section: "media",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/users/media')
  },
  {
    path: '/users/videolikes',
    name: 'users-videolikes',
    meta: {
      authRequired: true,
      section: "videolikes-censored",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/users/videolikes-censored.vue')
  },
  {
    path: '/users/updates',
    name: 'users-updates',
    meta: {
      authRequired: true,
      section: "updates",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/users/updates')
  },
  {
    path: '/users/featured-media',
    name: 'users-featured-media',
    meta : {
      authRequired: true,
      section: "featured-media",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/users/media-featured')
  },
  /*{
    path: '/users/fix-qrindex',
    name: 'users-fix-qrindex',
    meta : {
      authRequired: true,
      section: "fiq-qrindex",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/users/fix-qrindex.vue')
  },
  {
    path: '/users/fix-event-users',
    name: 'users-fix-event-users',
    meta : {
      authRequired: true,
      section: "fiq-event-users",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/users/fix-event-users.vue')
  },*/
  {
    path: '/users/beautiful-users',
    name: 'users-beautiful-users',
    meta : {
      authRequired: true,
      section: "beautiful-users",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/users/beautiful.vue')
  },
  {
    path: '/users/specials-users',
    name: 'users-specials-users',
    meta : {
      authRequired: true,
      section: "specials-users",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/users/specials.vue')
  },
  // moderation routes
  {
    path: '/moderation/checks',
    name: 'moderation-checks',
    meta: {
      authRequired: true,
      section: "moderation-checks",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/moderation/ModerationChecks.vue')
  },
  // marketing routes
  {
    path: '/marketing/installs',
    name: 'marketing-installs',
    meta: {
      authRequired: true,
      section: "installs",
      roleRequired: [Role.Admin, Role.Marketing, Role.MarketingGuest],
    },
    component: () => import('./views/marketing/installs')
  },
  {
    path: '/marketing/leads',
    name: 'marketing-leads',
    meta: {
      authRequired: true,
      section: "leads",
      roleRequired: [Role.Admin, Role.Marketing, Role.MarketingGuest],
    },
    component: () => import('./views/marketing/leads')
  },
  {
    path: '/marketing/updates',
    name: 'marketing-updates',
    meta: {
      authRequired: true,
      section: "app-updates",
      roleRequired: [Role.Admin, Role.Marketing, Role.MarketingGuest],
    },
    component: () => import('./views/marketing/updates')
  },
  {
    path: '/marketing/uninstalls',
    name: 'marketing-uninstalls',
    meta: {
      authRequired: true,
      section: "uninstalls",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/marketing/uninstalls')
  },
  // reports routes
  {
    path: '/support/reports',
    name: 'reports',
    meta: {
      authRequired: true,
      section: "report",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/support/reports')
  },
  {
    path: '/support/reports/:reportId',
    name: 'reportDetails',
    meta: {
      authRequired: true,
      section: "report",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/support/reportDetails')
  },
  // tickets routes
  {
    path: '/support/tickets',
    name: 'tickets',
    meta: {
      authRequired: true,
      section: "ticket",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/support/tickets')
  },
  {
    path: '/support/ticket/:ticketId',
    name: 'ticketDetails',
    meta: {
      authRequired: true,
      section: "ticket",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/support/ticketDetails')
  },
  {
    path: '/support/store-reviews',
    name: 'storeReviews',
    meta: {
      authRequired: true,
      section: "store-reviews",
      roleRequired: [Role.Admin],
    },
    component: () => import('./views/support/storeReviews')
  },
  // Finances routes
  {
    path: '/finance/transactions',
    name: 'finance-transactions',
    meta : {
      authRequired: true,
      section: "transactions",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/finance/transactions')
  },
  {
    path: '/finance/subscriptions',
    name: 'finance-subscriptions',
    meta : {
      authRequired: true,
      section: "subscriptions",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/finance/subscriptions')
  },
  {
    path: '/finance/packs',
    name: 'finance-packs',
    meta : {
      authRequired: true,
      section: "packs",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/finance/packs')
  },
  {
    path: '/finance/stats',
    name: 'finance-stats',
    meta : {
      authRequired: true,
      section: "stats",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/finance/stats.vue')
  },
  {
    path: '/finance/prices-test',
    name: 'finance-prices-test',
    meta : {
      authRequired: true,
      section: "prices",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/finance/prices-tests.vue')
  },
  {
    path: '/finance/slgroups',
    name: 'finance-slgroups',
    meta : {
      authRequired: true,
      section: "prices",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/finance/slGroups.vue')
  },
  {
    path: '/finance/pmgroups',
    name: 'finance-pmgroups',
    meta : {
      authRequired: true,
      section: "prices",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/finance/pmGroups.vue')
  },
  {
    path: '/finance/vat',
    name: 'finance-vat',
    meta : {
      authRequired: true,
      section: "vat",
      roleRequired: [Role.Admin, Role.Marketing],
    },
    component: () => import('./views/finance/vat-generator.vue')
  },
  {
    path: '/system/actions',
    name: 'system-logs',
    meta : {
      authRequired: true,
      section: "logs",
      roleRequired: [Role.Admin],
    },
    component: () => import('./views/system/actions')
  },
  {
    path: '/system/notifications',
    name: 'system-notifications',
    meta : {
      authRequired: true,
      section: "notifications",
      roleRequired: [Role.Admin],
    },
    component: () => import('./views/system/notifications')
  },
  {
    path: '/system/emails',
    name: 'system-emails',
    meta : {
      authRequired: true,
      section: "emails",
      roleRequired: [Role.Admin],
    },
    component: () => import('./views/system/emails')
  },
  {
    path: '/system/generator',
    name: 'system-generator',
    meta : {
      authRequired: true,
      section: "generator",
      roleRequired: [Role.Admin],
    },
    component: () => import('./views/system/generator')
  },
  {
    path: '/system/answers',
    name: 'system-answers',
    meta : {
      authRequired: true,
      section: "actions",
      roleRequired: [Role.Admin],
    },
    component: () => import('./views/system/actions-generator')
  },
  {
    path: '/system/ai-generator',
    name: 'system-ai-generator',
    meta : {
      authRequired: true,
      section: "ai-generator",
      roleRequired: [Role.Admin],
    },
    component: () => import('./views/system/ai_generator')
  },
  {
    path: '/system/ai-stats',
    name: 'system-ai-stats',
    meta : {
      authRequired: true,
      section: "ai-stats",
      roleRequired: [Role.Admin, Role.Marketing, Role.Operator],
    },
    component: () => import('./views/system/ai_stats')
  }
]
